import { InjectionToken, Signal } from '@angular/core';
import { ScheduleDetailsVM } from '@libs/schedule';

export const MY_COLLABORATION_SIDEBAR_APPOINTMENT = new InjectionToken<Signal<ScheduleDetailsVM | undefined>>(
  'MY_COLLABORATION_SIDEBAR_APPOINTMENT',
);

/**
 * Whether the right sidebar hosting this page is currently open. The sidebar keeps its content
 * mounted while collapsed, so anything that renders outside the sidebar's own box — the nurturing
 * arrow's CDK overlay, for one — has to consult this instead of relying on being unmounted.
 */
export const MY_COLLABORATION_SIDEBAR_VISIBLE = new InjectionToken<Signal<boolean>>('MY_COLLABORATION_SIDEBAR_VISIBLE');
